
import services from './../../services/service'; // Service Class
import SecondHeader from './../Second-Header/index.vue'; // Second Header
import MainFooter from './../Main-Footer/index.vue'; // Main Footer
//
import PaymentsAndUpdates from './../../mixins/payments_and_updates.js'; //  PaymentsAndUpdates == Resources
let service = new services();

export default {
name: 'Pricing',
mixins: [PaymentsAndUpdates],
data () {
    return {
        user:{},
        plans:{},
        plan:{},
        amount_paid: '',
        premium_message: '',
        request_page: '',
        plan_type: false,
        disable_btn: false,
        selected_plan: false,
        current_wallet_balance: 0,
        loggedIn: false,
    }
},
components: {
    'second-header': SecondHeader,
    'main-footer': MainFooter,
},
methods: {
    //settings
    preset() {
        var credentials = {
            session_key: localStorage.getItem("cityneeds_token")
        } 
        if(credentials.session_key != null) {
            service.sessionGuard(this, credentials).then(response => {
                if(response.body.status == 200) {
                    let data = response.body.data;
                    data.forEach(function(element) {
                            //this.user.user_id = element.user_id;
                            service.getUser(this, element.user_id).then(data => {
                                if(data.body.status == 200) {
                                    this.loggedIn = true;
                                    this.user = data.body.data;
                                    this.plan_type = true;
                                 }
                            }).catch((err) => {
                                if(err) {
                                   //log me
                                }
                            })
                    }, this);
                }else {
                    this.$router.push('/login');
                }
            }).catch((err) => {
                if(err) {
                    this.$router.push('/login');
                }
            })
        }else {
            this.$router.push('/login');
        }
            
    },
    check_free_plan(plan){
        if(plan.plan_id == 1){
            return 'none';
        }
    },
    //payments
    getPaymentPlans() {
        service.getPaymentPlans(this).then(data => {
            if(data.body.status == 200) {
                this.plans = data.body.data;
            }
        }).catch((err) => {
            if(err) {
                //toastr.error('Sorry, could not process information', 'Warning!');
            }
        })
    },

    getIncomingRequest(){
        if(localStorage.getItem("cityneeds_request_plans") == 'cnpro'){
            this.premium_message = true;
            this.request_page = 'cnpro';
            localStorage.removeItem("cityneeds_request_plans");
        }
        if(localStorage.getItem("cityneeds_request_plans") == 'profile'){
            this.request_page = 'profile';
            //localStorage.removeItem("cityneeds_request_plans");
        }
        localStorage.removeItem("cityneeds_request_plans");
     },

    presetPaymentPlan(plan) {
        this.selected_plan = plan;
        //open modal
        $('#paywith').modal();
    },


    setPaymentPlan(pay_with_option) {
        let plan = this.selected_plan;
        this.disable_btn = true;
        //check login
        localStorage.setItem("cn_prv_page","pricing"); //log current page
        //localStorage.setItem("cn_plan",plan.plan_id);

       // this.preset();
       var credentials = {
        session_key: localStorage.getItem("cityneeds_token")
        } 
        if(credentials.session_key != null) {
            service.sessionGuard(this, credentials).then(response => {
                if(response.body.status == 200) {
                    let data = response.body.data;
                    data.forEach(function(element) {
                        this.user.user_id = element.user_id;
                        //..
                        if(this.user.user_id != null){
                            var credentials = {
                                plan_user_id: this.user.user_id,
                                plan_plan: plan.plan_id,
                                plan_amount: plan.plan_amount
                            }
                            if(credentials.plan_plan != null) {
                                service.setPaymentPlan(this, credentials).then(data => {
                                if(data.body.status == 201) {
                                
                                    if(pay_with_option == "gateway"){
                                         //CALL PAYMENT GATEWAY
                                        this.processPayment(data.body.data);
                                    }else{
                                        this.processPaymentWithWallet(data.body.data)
                                    }
                                    localStorage.removeItem('cn_plan');
                                    
                                        
                                }else {
                                    toastr.error('Sorry, could not set plan', 'Warning!');
                                    this.disable_btn = false;
                                }
                                }).catch((err) => {
                                    if(err) {
                                        console.log(err)
                                        //toastr.error('Sorry, could not process information', 'Warning!');
                                        this.disable_btn = false;
                                    }
                                })
                            }else {
                                //toastr.error('Kindly fill all fields', 'Warning!');
                            
                            }
                            localStorage.removeItem('cn_plan')
                        }
                        //..
                    }, this);
                }else {
                    this.$router.push('/login');
                }
            }).catch((err) => {
                if(err) {
                    this.$router.push('/login');
                }
            })
        }else {
            this.$router.push('/login');
        }
        
    
    },
    
    //connect to a payment gateway
    processPayment(data) {
            let obj = this;
            this.amount_paid = data.plan_amount;
            var handler = PaystackPop.setup({
            //key: 'pk_test_5e386f2b137cecdea7db6839c293614a8a115742',
            key: 'pk_live_1e88da135e1bd1205b610cac36fc6d9a27a2fbd8',
            Name: data.plan_user,
            email: data.plan_user_email || "admin@cityneeds.ng",
            //email: "keneinfostream@gmail.com",
            amount:  (Math.round(data.plan_amount * 100)),//(data.plan_amount * 100), //in kobo
            ref: data.plan_ref,
            metadata: {
                custom_fields: [
                    {
                        display_name: "Customer Name",
                        variable_name: "customer_name",
                        value: data.plan_user
                    },
                    {
                        display_name: "Service",
                        variable_name: "service_type",
                        value: data.plan_user_name
                    }
                    
                ]
            },
            
            callback: function(response){
                //post transaction
                let txn_payload = {
                    "transaction_payment_ref": ref,
                    "transaction_module": 9,//CNplans---plans and registration
                    "transaction_module_id": obj.selected_plan.plan_id,
                    "transaction_type": 2, //User Plans Upgrade
                    "transaction_mode": 1, //Payment Gateway
                    "transaction_mode_transaction_ref":ref, //use here
                    "transaction_amount_paid": data.plan_amount,
                    "payer_name": obj.user.user_fullname || "",
                    "payer_email": obj.user.user_email || "", 
                    "payer_phone": obj.user.user_phone || 0,
                    "payer_user": obj.user.user_id || 0,
                };
                obj.postCNpaymentDetails(txn_payload);
                ///.///post transaction
                obj.updatePayment(response.trxref); 
                
            },
            onClose: function(){
                alert('window closed');
            }
            }); 
            handler.openIframe();
        },

    processPaymentWithWallet(data){
        this.amount_paid = data.plan_amount;
        var payload ={
            pay: this.user.user_id, // data.plan_user_id
            txn_amount: data.plan_amount,
            service: 1,//plans and registration
            service_ref: data.plan_ref
        }
        service.postWalletPayout(this, payload).then(response => {
            if(response.body.status == 201) {
                var txref = response.body.data_txn_ref;
                //post transaction
                let txn_payload = {
                    "transaction_payment_ref": data.plan_ref,
                    "transaction_module": 9,//CNplans---plans and registration
                    "transaction_module_id": this.selected_plan.plan_id,
                    "transaction_type": 2, //User Plans Upgrade
                    "transaction_mode": 2, //CNrewards-Wallet
                    "transaction_mode_transaction_ref":txref, //use here
                    "transaction_amount_paid": data.plan_amount,
                    "payer_name": this.user.user_fullname || "",
                    "payer_email": this.user.user_email || "", 
                    "payer_phone": this.user.user_phone || 0,
                    "payer_user": this.user.user_id || 0,
                };
                this.postCNpaymentDetails(txn_payload);
                ///.///post transaction
                
                this.updatePayment(response.body.data)
            }
        }).catch((err) => {
            if(err) {
                toastr.error('Sorry, could not process information', 'Warning!');
            }
        })
    },

        // update payments
        updatePayment(payment_ref) {
             var credentials = {
                amount_paid: this.amount_paid,
                plan_user_id: this.user.user_id,
                record_transaction:0,
            }
            let navi = this.$router;
            
            if(payment_ref != "") {
                service.updatePaymentPlan(this, payment_ref, credentials).then(data => {
                    if(data.body.status == 200) {
                        toastr.success("Payment Processed!", "Success!");
                        
                        if(this.request_page != ''){
                            this.$router.push(this.request_page);
                        }else {
                            this.$router.go('/');
                        }
                    }else {
                        toastr.error('Sorry, could not update payment', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }else {
               toastr.error('Something went wrong', 'Warning!');
            }
            
        },

    //wallet calls
    getWalletTransactions() {
        let user_id = localStorage.getItem("cityneeds_token_key");
        service.getWalletTransactions(this,user_id).then(data => {
             if(data.body.status == 200) {
                 this.current_wallet_balance = data.body.data_current_wallet_balance;
             }
         }).catch((err) => {
             if(err) {
                 toastr.error('Sorry, could not process information', 'Warning!');
             }
         })
    },

    formatCurrency(currency){
        currency =  Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN'}).format(currency);
        return currency.replace("NGN", ""); //strip off NGN
    },

    //....wallet calls
},


created: function(){
    this.getPaymentPlans();
    this.getIncomingRequest();
    this.getWalletTransactions();
    if(localStorage.getItem("cityneeds_user") != null) {
        this.preset();
    }
}

}


// WEBPACK FOOTER //
// ./src/components/Pricing/script.js